export const DATA_AUTOMATION_NAMES = ["news", "section"];
